/* @flow */

import { rem } from 'polished';

import { white } from '@e180/ui/lib/token/palette';
import { baseFontSize } from '@e180/ui/lib/token/typography';

export default {
  root: {
    color: white,

    fontSize: rem(12, baseFontSize),
    lineHeight: 14 / 12,
    textDecoration: 'none',
    WebkitFontSmoothing: 'antialiased',

    '&:visited': {
      color: white,
    },
    '&:hover': {
      color: white,

      textDecoration: 'underline',
    },
    '&:active': {
      color: white,

      textDecoration: 'underline',
    },
  },
};
